import { Text } from '@chakra-ui/react';

export const XsSpan = ({ children }: { children: React.ReactNode }) => {
  return (
    <Text as={'span'} fontWeight={'bold'}>
      {children}
    </Text>
  );
};
